const ON_SCROLL = 'app/ON_SCROlL';
const SET_BROWSER_TYPE = 'app/SET_BROWSER_TYPE';

export default {
  ON_SCROLL,
  SET_BROWSER_TYPE
};



// WEBPACK FOOTER //
// ./src/state/app/types.js